module.exports = {"zh":{"word":{"group":"组管理","createGroup":"创建组","deviceCount":"设备数量"}},"en":{"word":{"group":"Group Management","createGroup":"Create Group","deviceCount":"Equipment Quantity"}},"nb":{"word":{"group":"Gruppeadministrasjon","createGroup":"Lag gruppe","deviceCount":"Antall enheter"}},"he":{"word":{"group":"ניהול קבוצה","createGroup":"צור קבוצה","deviceCount":"כמות ציוד"}},"de":{"word":{"group":"Gruppen Management","createGroup":"Gruppe erstellen","deviceCount":"Ausrüstungsmenge"}}}


//////////////////
// WEBPACK FOOTER
// ./static/i18n/group.json
// module id = VAcA
// module chunks = 25